import { render, staticRenderFns } from "./jiangxuejin-list.vue?vue&type=template&id=0e4d9de3&scoped=true&"
import script from "./jiangxuejin-list.vue?vue&type=script&lang=js&"
export * from "./jiangxuejin-list.vue?vue&type=script&lang=js&"
import style0 from "./jiangxuejin-list.vue?vue&type=style&index=0&id=0e4d9de3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d9de3",
  null
  
)

export default component.exports